import WithdrawProposal from './WithdrawProposal';
export default WithdrawProposal;